import "babel-polyfill"; // 解决Ie9
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "./element";
import * as filters from "./filtres/index"; // 全局过滤器
import { checkPermission } from "./role"; // 权限
import common from "@/utils/common.js";
import tableToolTip from "@/components/tableTooptip.vue"
import { bootstrap } from "@/services/bootstrap.js"; // 应用启动初始化服务

// import "./mock"; // 模拟数据

import "./assets/icons/iconfont";
import IconSvg from "./components/common/IconSvg.vue"; // svg组件
import tableAsinColumn from "./components/common/tableAsinColumn.vue"; // svg组件
import formRangeItem from "./components/common/formRangeItem.vue"; // svg组件
import formNewRangeItem from "./components/common/formNewRangeItem.vue"; // svg组件
import formXPItem from "./components/common/formXPItem.vue"; // svg组件
import formXPItem1 from "./components/common/formXPItem1.vue"; // svg组件

import VuevideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
Vue.use(VuevideoPlayer);

// 注册全局组件（register global）
Vue.component("icon-svg", IconSvg);
Vue.component("tableAsinColumn", tableAsinColumn);
Vue.component("formRangeItem", formRangeItem);
Vue.component("formNewRangeItem", formNewRangeItem);
Vue.component("formXPItem", formXPItem);
Vue.component("formXPItem1", formXPItem1);
Vue.component("tableToolTip", tableToolTip);
//导出excel
import JsonExcel from "vue-json-excel";
import {MessageBox} from "element-ui";
Vue.component("downloadExcel", JsonExcel);

// 注册全局实用程序过滤器（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
Vue.prototype.$downLoadPlug = ()=>{
    MessageBox.confirm("插件新版本发布是否下载", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
    }).then(() => {
        const a = document.createElement("a");
        a.setAttribute("href", "/export/大数据1.0.8.zip");
        a.target = "_blank";
        a.click();
    }).catch(() => {});
}
Vue.prototype.$checkPermission = checkPermission
Vue.prototype.$common = common // 公共变量存储

Vue.config.productionTip = false;

// 应用启动初始化
bootstrap().finally(() => {
    // 创建 Vue 实例并挂载
    new Vue({
        router,
        store,
        render: h => h(App),
        beforeCreate() {
            Vue.prototype.$bus = this;
        }
    }).$mount("#app");
});
